export const WITHDRAW_DISCOUNT_PERCENT = '0.001';
export const WITHDRAW_DAYS_VALID = '3';
